import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "asus_proart_sw_ico_download",
  "use": "asus_proart_sw_ico_download-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"asus_proart_sw_ico_download\"><g id=\"asus_proart_sw_ico_download_asus_proart_sw_ico_download\"><path d=\"M41,29.33V36a5,5,0,0,1-5,5H12a5,5,0,0,1-5-5V29.33H9V36a3,3,0,0,0,3,3H36a3,3,0,0,0,3-3V29.33Zm-17,1a1,1,0,0,0,.71-.29l8.89-8.89-1.42-1.41L25,26.92V8H23V26.92l-7.18-7.18L14.4,21.15,23.29,30A1,1,0,0,0,24,30.33Z\" /><rect width=\"48\" height=\"48\" fill=\"none\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol